import React from "react";
import { getImageUrl } from "../util/db";

function PrintImage(props) {
  const { printRef, imgPath, bucket = "creations" } = props;
  return (
    <div style={{ display: "none" }}>
      <div ref={printRef} style={{ textAlign: "center" }}>
        <p style={{ color: "black", fontSize: 30, marginBottom: 0 }}>
          BLACK<strong>INK</strong>.AI
        </p>
        <p style={{ color: "black", marginBottom: 0 }}>
          Create your own unique flash tattoo in seconds.
        </p>
        <p style={{ color: "black", marginBottom: 0 }}>www.blackink.ai</p>
        {imgPath && (
          <img
            src={getImageUrl(imgPath, bucket)}
            alt=""
            loading="lazy"
            style={{
              backgroundColor: "white",
            }}
          />
        )}
      </div>
    </div>
  );
}

export default PrintImage;
